// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"Spinner_spinnerWrapper__8+8pG"};